const RISKY_PREFIX = /^[=+\-@\t\r]/;
const DTO_PHONE_PATTERN = /^\+?[1-9]\d{7,14}$/;
const PHONE_HEADER_TOKENS = [
  'telefone',
  'telefone1',
  'telefone2',
  'telefone3',
  'fone',
  'celular',
  'phone',
  'phone1',
  'phone2',
  'phone3',
  'numero',
  'número',
  'contato',
  'whatsapp',
];

export const MAX_DNC_PHONES = 100000;
export const DNC_CHUNK_SIZE = 5000;

const csvCell = (value) => {
  if (value === null || value === undefined) return '""';
  const raw = String(value);
  const guarded = RISKY_PREFIX.test(raw) ? `'${raw}` : raw;
  return `"${guarded.replace(/"/g, '""')}"`;
};

export const buildCsv = (header, rows) => {
  const lines = [header.map(csvCell).join(';')];
  rows.forEach((row) => lines.push(row.map(csvCell).join(';')));
  return `﻿${lines.join('\r\n')}\r\n`;
};

export const downloadCsv = (filename, header, rows) => {
  const blob = new Blob([buildCsv(header, rows)], { type: 'text/csv;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const downloadCampaignTemplate = () =>
  downloadCsv(
    'modelo-campanha.csv',
    ['nome', 'telefone', 'telefone2', 'telefone3', 'external_id'],
    [
      ['Maria Silva', '11999998888', '1133334444', '', 'CLI-001'],
      ['Joao Souza', '21988887777', '', '', 'CLI-002'],
    ],
  );

export const downloadDncTemplate = () =>
  downloadCsv('modelo-lista-bloqueio.csv', ['telefone'], [['11999998888'], ['1133334444']]);

const splitLines = (text) =>
  String(text || '')
    .replace(/^﻿/, '')
    .split(/\r?\n/);

export const buildManualImportFile = (text) => {
  const rows = splitLines(text)
    .map((line) => line.trim())
    .filter((line) => line !== '')
    .map((line) => [line]);
  const csv = buildCsv(['telefone'], rows);
  return new File([csv], 'contatos-manual.csv', { type: 'text/csv' });
};

const detectDelimiter = (line) => {
  const candidates = [';', ',', '\t'];
  let best = ';';
  let bestCount = 0;
  candidates.forEach((candidate) => {
    const count = line.split(candidate).length - 1;
    if (count > bestCount) {
      bestCount = count;
      best = candidate;
    }
  });
  return bestCount > 0 ? best : null;
};

const splitRow = (line, delimiter) =>
  (delimiter ? line.split(delimiter) : [line]).map((cell) => cell.trim().replace(/^"|"$/g, ''));

const stripDialPrefix = (digits) => {
  if (digits.startsWith('0055')) return digits.slice(4);
  if (digits.startsWith('0') && digits.length > 10) return digits.slice(1);
  return digits;
};

export const toDncToken = (raw) => {
  const digits = String(raw || '').replace(/\D/g, '');
  if (digits === '') return null;
  const token = stripDialPrefix(digits);
  return DTO_PHONE_PATTERN.test(token) ? token : null;
};

export const extractDncPhones = (text) => {
  const lines = splitLines(text);
  const firstNonEmpty = lines.findIndex((line) => line.trim() !== '');
  if (firstNonEmpty === -1) {
    return { phones: [], invalid: [], invalidCount: 0, truncated: false };
  }

  const delimiter = detectDelimiter(lines[firstNonEmpty]);
  const headerCells = splitRow(lines[firstNonEmpty], delimiter).map((cell) => cell.toLowerCase());
  const headerColumn = headerCells.findIndex((cell) => PHONE_HEADER_TOKENS.includes(cell));
  const hasHeader = headerColumn !== -1;
  const column = hasHeader ? headerColumn : 0;

  const seen = new Set();
  const phones = [];
  const invalid = [];
  let invalidCount = 0;
  let truncated = false;

  for (let index = hasHeader ? firstNonEmpty + 1 : firstNonEmpty; index < lines.length; index += 1) {
    const line = lines[index];
    if (line.trim() === '') continue;

    const cells = splitRow(line, delimiter);
    const value = cells[column] ?? cells[0] ?? '';
    if (value.trim() === '') continue;

    const token = toDncToken(value);
    if (!token) {
      invalidCount += 1;
      if (invalid.length < 10) invalid.push({ line: index + 1, value: value.slice(0, 40) });
      continue;
    }

    if (seen.has(token)) continue;
    if (phones.length >= MAX_DNC_PHONES) {
      truncated = true;
      break;
    }
    seen.add(token);
    phones.push(token);
  }

  return { phones, invalid, invalidCount, truncated };
};

export const chunkPhones = (phones, size = DNC_CHUNK_SIZE) => {
  const chunks = [];
  for (let index = 0; index < phones.length; index += size) {
    chunks.push(phones.slice(index, index + size));
  }
  return chunks;
};
